import { useState, useEffect } from "react";
import { departmentDetailService } from "Services/AdminServices/Organization/DepartmentDetailService";
import { message } from "antd";

export const useJobTitles = () => {
  const [departments, setDepartments] = useState([]);
  const [loadingDepts, setLoadingDepts] = useState(false);
  const [loadingCareerPaths, setLoadingCareerPaths] = useState(false);
  const [ careerPaths, setCareerPaths] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);

  const fetchDepartmentList = async () => {
    try {
      setLoadingDepts(true);
      const data = await departmentDetailService.getDepartmentList();
      setDepartments(data);
    } catch (error) {
      console.error("Error fetching departments", error);
      message.error("Failed to load departments");
    } finally {
      setLoadingDepts(false);
    }
  };

  const fetchCareerPaths = async (departmentId) => {
    try {
      setLoadingCareerPaths(true);
      const data = await departmentDetailService.getCareerPaths(departmentId);
      setCareerPaths(data);
    } catch (error) {
      console.error("Error in fetching Job Titles", error);
    } finally {
      setLoadingCareerPaths(false);
    }
  };

  const fetchJobTitles = async (departmentId) => {
    if (!departmentId) return;
    try {
      setLoadingJobs(true);
      const data = await departmentDetailService.getJobTitles(departmentId);
      setJobTitles(data);
    } catch (error) {
      console.error("Error fetching job titles", error);
      message.error("Failed to load job titles");
    } finally {
      setLoadingJobs(false);
    }
  };

  return {
    departments,
    loadingDepts,
    jobTitles,
    loadingJobs,
    fetchDepartmentList,
    fetchJobTitles,
    fetchCareerPaths,
    loadingCareerPaths,
    careerPaths
  };
};